// removed by extract-text-webpack-plugin
module.exports = {"content":"Home__content__4md9A","parentContainer":"Home__parentContainer__3dFRQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 854
// module chunks = 0